// @mui icons
import Icon from '@mui/material/Icon'
import Dashboard from './dashboard'
import Onboard from './OnBoardList'


import MarketplaceApps from './MarketplaceApps'
import Changelogs from './Changelogs'

import AppTriggerModel from './AppTriggerModel'
import UnlimitedFaq from './UnlimitedFaq'
import LocationFaqs from './locationFaqs'
import Roadmap from './RoadMap'
import PromptTemplates from './PromptTemplates'
import RoadMapCompany from './RoadMapCompany'

import UserInstalls from './UserInstalls'











import { useUserInfo } from 'context/user'



function useRoutes() {
  const [user] = useUserInfo()
  console.log('user', user)

  const allRoutes = [
    {
      type: 'collapse',
      name: 'Dashboard',
      key: 'dashboard',
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: '/dashboard',
      component: <Dashboard />,
    },
    {
      type: 'collapse',
      name: 'Onboard list',
      key: 'onboardcategory',
      icon: <Icon fontSize="small">Onboard</Icon>,
      route: '/onboarding/*',
      component: <Onboard />,
    },
    {
      type: 'collapse',
      name: 'Changelogs',
      key: 'changelogs',
      icon: <Icon fontSize="small">changelogs</Icon>,
      route: '/changelogs',
      component: <Changelogs />,
    },
  {
      type: 'collapse',
      name: 'Roadmap',
      key: 'roadmap',
      icon: <Icon fontSize="small">roadmap</Icon>,
      route: '/roadmap/*',
      collapse: [
        {
          type: 'collapse',
          name: 'roadmap',
          key: 'roadmap',
          icon: <Icon fontSize="small">roadmap</Icon>,
          route: '/roadmap',
          component: <Roadmap />,
        },
        {
          type: 'collapse',
          name: 'Roadmap Details',
          key: 'roadmap_details',
          icon: <Icon fontSize="small">roadmap</Icon>,
          route: '/roadmap_details',
          component: <RoadMapCompany />,
        },

      ],
    },
      {
      type: 'collapse',
      name: 'prompt-templates',
      key: 'prompt-templates',
      icon: <Icon fontSize="small">prompt templates</Icon>,
      route: '/prompt-templates',
      component: <PromptTemplates />,
    },
    {
      type: 'collapse',
      name: 'user-installs',
      key: 'User Installs',
      icon: <Icon fontSize="small">User Installs</Icon>,
      route: '/user-installs',
      component: <UserInstalls />,
    },


    
    
    // {
    //   type: 'collapse',
    //   name: 'FAQs',
    //   key: 'faq',
    //   icon: <Icon fontSize="small">help_outline</Icon>,
    //   route: '/faq',
    //   collapse: [

    //     {
    //       type: 'collapse',
    //       name: 'Agency FAQs',
    //       key: 'unlimited_faq',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/unlimited_faq',
    //       component: <UnlimitedFaq />,
    //     },
    //     {
    //       type: 'collapse',
    //       name: 'Locations FAQs',
    //       key: 'location_faqs',
    //       icon: <Icon fontSize="small">list</Icon>,
    //       route: '/location_faqs',
    //       component: <LocationFaqs />,
    //     },
    //   ],
    // },





  ]

  // Only allow "superadmin" and "manager" to see all routes
  const allowedRoles = ['superadmin', 'manager']

  if (user?.roles?.some((role) => allowedRoles.includes(role))) {
    return allRoutes // Full access for superadmin/manager
  }

  if (user?.roles?.some((role) => role === 'onboarding_admin')) {
    const allowedKeys = new Set([
      'changelogs', // Changelogs
      'newsfeeds', // News feed
      'players', // Players (+ sub-routes)
      'partner', // Partners
      'medialibrary', // Media library (+ sub-routes)
      'awardgroup', // Award Ranking (+ sub-routes)
      'banners', // Banners (unique key)
      'tooltip', // ToolTip (unique key)
      'checklist', // Check list (+ sub-routes)
      'questions', // Questions (+ sub-routes)
      'faq', // FAQs (+ sub-routes)
      'knowledgebase', // Knowledge Base (+ sub-routes)
      'onboardcategory', // Onboard list (+ sub-routes)
    ])

    return allRoutes.filter((route) => allowedKeys.has(route.key))
  }
  if (user?.roles?.some((role) => role === 'client')) {
    const allowedKeys = new Set([
      'partner',
    ])

    return allRoutes.filter((route) => allowedKeys.has(route.key))
  }
  if (user?.roles?.some((role) => role === 'bid_data')) {
    const allowedKeys = new Set([
      'partner', // Partners
      'partnersaas',
    ])

    return allRoutes.filter((route) => allowedKeys.has(route.key))
  }

  // Fallback for non-admin users (e.g., regular users)
  return [
    {
      type: 'collapse',
      name: 'Dashboard',
      key: 'dashboard',
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: '/dashboard',
      component: <Dashboard />,
    },

  ]
}

export default useRoutes
